import React from 'react';
import { Anchor, Box, Heading, Page, PageContent, Text } from 'grommet';
import { useLoaderData } from 'react-router-dom';
import { API } from '../../api';

export const CompanyProfile = ({ showAdminActions = true }) => {
    const company = useLoaderData();
    const jobs = company?.attributes?.jobs?.data || [];
    const openJobs = jobs.filter(
        (j) => j.attributes.status.toLowerCase() !== 'closed',
    );
    const closedJobs = jobs.filter(
        (j) => j.attributes.status.toLowerCase() === 'closed',
    );

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent>
                <Heading level="2">{company?.attributes?.name}</Heading>
                {company?.attributes?.isContractClient && (
                    <Box
                        alignSelf="start"
                        background="enrich-green-light"
                        round="6px"
                        pad="small">
                        <Text>Contract Client</Text>
                    </Box>
                )}

                <Box gap="medium" margin={{ top: 'medium' }}>
                    <Box>
                        <Heading level="3" margin={{ bottom: 'small' }}>
                            Open Roles
                        </Heading>
                        <Box elevation="medium" pad="medium">
                            {openJobs.length > 0 ? (
                                <Box gap="xsmall">
                                    {openJobs.map((job) =>
                                        showAdminActions ? (
                                            <Anchor
                                                key={job.id}
                                                href={`/jobs/${job.id}`}
                                                label={job.attributes.title}
                                            />
                                        ) : (
                                            <Text key={job.id}>
                                                {job.attributes.title}
                                            </Text>
                                        ),
                                    )}
                                </Box>
                            ) : (
                                <Text color="dark-4">No open roles</Text>
                            )}
                        </Box>
                    </Box>

                    {showAdminActions && closedJobs.length > 0 && (
                        <Box>
                            <Heading level="3" margin={{ bottom: 'small' }}>
                                Closed Roles
                            </Heading>
                            <Box elevation="medium" pad="medium">
                                <Box gap="xsmall">
                                    {closedJobs.map((job) => (
                                        <Anchor
                                            key={job.id}
                                            href={`/jobs/${job.id}`}
                                            label={job.attributes.title}
                                        />
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            </PageContent>
        </Page>
    );
};

export async function loader({ params }) {
    const companyQuery = `query getCompany($companyId: ID!) {
        company(id: $companyId) {
            data {
                id
                attributes {
                    name
                    isContractClient
                    jobs {
                        data {
                            id
                            attributes {
                                title
                                status
                            }
                        }
                    }
                }
            }
        }
    }`;

    try {
        const response = await API.post('graphql', {
            query: companyQuery,
            variables: { companyId: params.companyId },
        });
        return response.data.data.company.data;
    } catch (error) {
        console.log(error);
        return {};
    }
}
